import api from "./axios";

const getHttpMethod = (err) => {
  const method = err?.config?.method;
  if (typeof method === "string" && method.trim()) {
    return method.toUpperCase();
  }
  return null;
};

const getRequestUrl = (err) => {
  const url = err?.config?.url;
  if (typeof url === "string" && url.trim()) {
    try {
      const parsed = new URL(url, window.location.origin);
      return `${parsed.origin}${parsed.pathname}`;
    } catch {
      return url.split("?")[0];
    }
  }
  return null;
};

export async function sendClientErrorLog({
  source,
  stage,
  err,
  referenceType = null,
  referenceId = null,
  referenceLabel = null,
  fileSnapshot = null,
  extra = null,
}) {
  try {
    await api.post("/api/client-error-log", {
      source,
      stage,
      status: err?.response?.status ?? null,
      method: getHttpMethod(err),
      requestUrl: getRequestUrl(err),
      pageUrl: window.location.href,
      clientOccurredAt: new Date().toISOString(),
      errorType: err?.name || "ClientError",
      resultMessage: err?.response?.data?.resultMessage ?? null,
      message: err?.response?.data?.message ?? err?.message ?? null,
      userAgent: navigator.userAgent,
      referenceType,
      referenceId,
      referenceLabel,
      fileSnapshot,
      extra,
    });
  } catch (logErr) {
    console.error("Failed to send client error log", logErr);
  }
}
